import axios from 'axios'

export type ContractorEntityDocument = {
  id: number
  contractorEntityId: number
  documentTypeId: number
  documentUuid: string
  customProperties: Record<string, unknown> | null
  status: string
  expiresAt: string | null
  createdAt: string
  updatedAt: string
  timezone: string | null
}

export type ContractorEntityDocumentRequirement = {
  id: number
  contractorEntityId: number
  documentTypeId: number
  requiredBy: string
  timezone: string | null
  createdAt: string
  updatedAt: string
  contractorEntityDocuments: ContractorEntityDocument[]
  documentType: { id: number; name: string } | null
  entity: { id: number; name: string } | null
  contractorCompany: { id: number; name: string } | null
}

export const getContractorEntityDocumentRequirements = async (
  entityIds: number[],
  contractorCompanyId: number,
): Promise<ContractorEntityDocumentRequirement[]> => {
  const response = await axios.get(
    '/api/contractor-entity-document-requirements',
    {
      params: {
        contractorCompanyId,
        entityIds,
        relations: ['contractorEntityDocuments'],
      },
    },
  )

  return response.data.data
}

export const storeFailedContractorCompliance = async (
  entityId: number,
  siteId: number,
  contractorCompanyId: number,
): Promise<void> => {
  await axios.post('/api/contractor-compliance-check-failed', {
    contractorCompanyId,
    entityId,
    siteId,
  })
}
